module.exports = __webpack_public_path__ + "/images/video-explicativo.1cfe13a.mp4";